import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import '@/index.css';
import { initPromise } from '@/i18n';
import { Loader2 } from '@/icons';

const RootLoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', backgroundColor: 'transparent' }}>
    <Loader2 style={{ height: '3rem', width: '3rem', animation: 'spin 1s linear infinite' }} />
  </div>
);

const ErrorFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', padding: '20px', textAlign: 'center' }}>
    <p>Failed to load application resources. Please try refreshing the page or contact support if the issue persists.</p>
  </div>
);

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(<RootLoadingFallback />);

// Add a timeout to prevent infinite loading
const timeoutId = setTimeout(() => {
  console.error('i18n initialization timed out after 10 seconds');
  root.render(<ErrorFallback />);
}, 10000);

// Try to render immediately with a fallback
const renderApp = () => {
  clearTimeout(timeoutId);
  root.render(
    <React.StrictMode>
      <Suspense fallback={<RootLoadingFallback />}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Suspense>
    </React.StrictMode>
  );
};

// Try i18n first, but don't let it block the app
initPromise.then(() => {
  renderApp();
}).catch(error => {
  console.error('i18n initialization failed:', error);
  renderApp();
});

// Fallback: render app after 3 seconds regardless
setTimeout(() => {
  renderApp();
}, 3000);
  
